import React from 'react'

const ApplicationButton = ({ activeTab, comData }) => {
    return (
        <button
            className={`tab-button ${activeTab === "application" ? "active" : ""
                }`}
            onClick={() => {
                window.open(comData?.application_doc || comData?.application_url, "_blank");
            }}
            style={{ backgroundColor: "white", opacity: !comData?.application_doc && !comData?.application_url ? 0.5 : 1, pointerEvents: !comData?.application_doc && !comData?.application_url ? "none" : "auto" }}
        >
            <span className="application-icon-svg">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="39"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#262626"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <rect
                        x="4"
                        y="2"
                        width="16"
                        height="20"
                        rx="2"
                        ry="2"
                    />

                    <line x1="8" y1="6" x2="16" y2="6" />

                    <line x1="8" y1="10" x2="16" y2="10" />

                    <polyline
                        points="8 14 12 18 16 14"
                        stroke="blue"
                        strokeWidth="1"
                    />
                </svg>
            </span>
            <span>Application</span>
        </button>
    )
}

export default ApplicationButton